"use client";

import { useEffect, useState } from "react";

import { setIsStreaming } from "@/context/redux/reducers/chat-slice";
import { Oriented } from "@/data/constants/oriented";
import { useAppDispatch } from "@/hooks/redux-hooks";
import { isJSON } from "@/utils/is-json";

import { Button } from "ui/core/button";

import { useChat } from "../../hooks/use-chat";
import { useDefaultQuestions } from "../../services/get-default-questions";

export const DefaultQuestions = () => {
  const dispatch = useAppDispatch();
  const { data: defaultQuestions } = useDefaultQuestions();
  const { handleSubmit } = useChat();

  const [investStyle, setInvestStyle] = useState<Oriented | null>(null);

  useEffect(() => {
    const storage = localStorage.getItem("investStyle");
    const investStyle = storage ? JSON.parse(storage) : null;
    setInvestStyle(investStyle);
  }, []);

  useEffect(() => {
    const handleChangeInvestStyle = (e: Event) => {
      const customEvent = e as CustomEvent;
      const investStyle = isJSON(customEvent.detail)
        ? JSON.parse(customEvent.detail)
        : customEvent.detail;
      setInvestStyle(investStyle);
    };

    if (typeof window !== "undefined")
      window.addEventListener("changeInvestStyle", handleChangeInvestStyle);

    return () => {
      if (typeof window !== "undefined")
        window.removeEventListener(
          "changeInvestStyle",
          handleChangeInvestStyle
        );
    };
  }, []);

  const handleClick = (question: string) => {
    handleSubmit({
      query: question,
      investStyle,
      isDefaultQuestion: true,
    });
    dispatch(setIsStreaming(true));
  };

  return (
    <div className="grid:cols-1 grid gap-x-10 gap-y-4 sm:grid-cols-2 sm:pl-16">
      {defaultQuestions?.map((question, index) => (
        <Button
          key={question}
          variant="secondary"
          onClick={() => handleClick(question)}
          data-testid={`default-question-${index}`}
        >
          {question}
        </Button>
      ))}
    </div>
  );
};
